import { apolloClientQuery, apolloClientMutate } from 'apollo-util';
import {
  HOME_PAGE_QUERY,
  COMMON_APP_QUERY,
  PROJECTS_PAGE_QUERY,
  CONTACT_PAGE_QUERY,
  LEGAL_QUERY,
  OUR_COMPANY_PAGE_QUERY,
  WHAT_WE_DO_PAGE_QUERY
} from 'services-graphql/querys/pages';
import { CATEGORIES_QUERY } from 'services-graphql/querys/categories';
import {
  PROJECTS_SUMMARY_QUERY,
  PROJECT_BY_SLUG,
  PROJECTS_FOR_HOME_QUERY
} from 'services-graphql/querys/projects';
import { CREATE_GET_IN_TOUCH_MUTATION } from 'services-graphql/mutations/getInTouch';
import { REVIEWS_QUERY } from 'services-graphql/querys/reviews';
import { EMPLOYEES_QUERY } from 'services-graphql/querys/employees';
import {
  SET_WEBSITE_PROPERTY,
  GET_WEBSITE_HOME_PAGE_DATA,
  GET_APP_COMMON_DATA,
  GET_WEBSITE_CONTACT_PAGE_DATA,
  GET_WEBSITE_LEGAL_DATA,
  CREATE_GET_IN_TOUCH,
  GET_WEBSITE_PROJECTS_PAGE_DATA,
  GET_WEBSITE_OUR_COMPANY_PAGE_DATA,
  GET_WEBSITE_WHAT_WE_DO_PAGE_DATA,
  GET_CATEGORIES_DATA,
  GET_PROJECTS_SUMMARY_DATA,
  GET_PROJECT_BY_SLUG_DATA,
  GET_PROJECTS_FOR_HOME_DATA,
  GET_REVIEWS_DATA,
  GET_EMPLOYEES_DATA
} from 'store/actions/website';

export default {
  [SET_WEBSITE_PROPERTY]: ({ commit }, { field, value }) =>
    commit(SET_WEBSITE_PROPERTY, {
      field,
      value
    }),

  [GET_APP_COMMON_DATA]: ({ commit, getters }, locale) =>
    new Promise((resolve, reject) => {
      if (!getters.dataWebsite('commonApp')) {
        apolloClientQuery(COMMON_APP_QUERY[locale], {}, false)
          .then(data => {
            commit(SET_WEBSITE_PROPERTY, {
              field: 'commonApp',
              value: data.common
            });
            resolve();
          })
          .catch(err => {
            commit('ERROR_OCCURRED', err, {
              root: true
            });
            reject();
          });
      } else {
        resolve();
      }
    }),

  [GET_WEBSITE_HOME_PAGE_DATA]: ({ commit, getters }, locale) =>
    new Promise((resolve, reject) => {
      if (!getters.dataWebsite('home')) {
        apolloClientQuery(HOME_PAGE_QUERY[locale])
          .then(data => {
            commit(SET_WEBSITE_PROPERTY, {
              field: 'home',
              value: data.home
            });
            resolve();
          })
          .catch(err => {
            commit('ERROR_OCCURRED', err, {
              root: true
            });
            reject();
          });
      } else {
        resolve();
      }
    }),

  [GET_WEBSITE_PROJECTS_PAGE_DATA]: ({ commit, getters }, locale) =>
    new Promise((resolve, reject) => {
      if (!getters.dataWebsite('project')) {
        apolloClientQuery(PROJECTS_PAGE_QUERY[locale])
          .then(data => {
            commit(SET_WEBSITE_PROPERTY, {
              field: 'project',
              value: data.project
            });
            resolve();
          })
          .catch(err => {
            commit('ERROR_OCCURRED', err, {
              root: true
            });
            reject();
          });
      } else {
        resolve();
      }
    }),

  [GET_WEBSITE_OUR_COMPANY_PAGE_DATA]: ({ commit, getters }, locale) =>
    new Promise((resolve, reject) => {
      if (!getters.dataWebsite('company')) {
        apolloClientQuery(OUR_COMPANY_PAGE_QUERY[locale])
          .then(data => {
            commit(SET_WEBSITE_PROPERTY, {
              field: 'company',
              value: data.company
            });
            resolve();
          })
          .catch(err => {
            commit('ERROR_OCCURRED', err, {
              root: true
            });
            reject();
          });
      } else {
        resolve();
      }
    }),

  [GET_WEBSITE_WHAT_WE_DO_PAGE_DATA]: ({ commit, getters }, locale) =>
    new Promise((resolve, reject) => {
      if (!getters.dataWebsite('whatWeDo')) {
        apolloClientQuery(WHAT_WE_DO_PAGE_QUERY[locale])
          .then(data => {
            commit(SET_WEBSITE_PROPERTY, {
              field: 'whatWeDo',
              value: data.whatWeDo
            });
            resolve();
          })
          .catch(err => {
            commit('ERROR_OCCURRED', err, {
              root: true
            });
            reject();
          });
      } else {
        resolve();
      }
    }),

  [GET_WEBSITE_CONTACT_PAGE_DATA]: ({ commit, getters }, locale) =>
    new Promise((resolve, reject) => {
      if (!getters.dataWebsite('contact')) {
        apolloClientQuery(CONTACT_PAGE_QUERY[locale])
          .then(data => {
            commit(SET_WEBSITE_PROPERTY, {
              field: 'contact',
              value: data.contact
            });
            resolve();
          })
          .catch(err => {
            commit('ERROR_OCCURRED', err, {
              root: true
            });
            reject();
          });
      } else {
        resolve();
      }
    }),

  [GET_WEBSITE_LEGAL_DATA]: ({ commit, getters }, locale) =>
    new Promise((resolve, reject) => {
      if (!getters.dataWebsite('legal')) {
        apolloClientQuery(LEGAL_QUERY[locale])
          .then(data => {
            commit(SET_WEBSITE_PROPERTY, {
              field: 'legal',
              value: data.legal
            });
            resolve();
          })
          .catch(err => {
            commit('ERROR_OCCURRED', err, {
              root: true
            });
            reject();
          });
      } else {
        resolve();
      }
    }),

  [GET_CATEGORIES_DATA]: ({ commit, getters }, locale) =>
    new Promise((resolve, reject) => {
      if (!getters.dataWebsite('categories')) {
        apolloClientQuery(CATEGORIES_QUERY[locale])
          .then(data => {
            commit(SET_WEBSITE_PROPERTY, {
              field: 'categories',
              value: data.projectCategories
            });
            resolve();
          })
          .catch(err => {
            commit('ERROR_OCCURRED', err, {
              root: true
            });
            reject();
          });
      } else {
        resolve();
      }
    }),

  [GET_PROJECTS_SUMMARY_DATA]: ({ commit, getters }, locale) =>
    new Promise((resolve, reject) => {
      if (!getters.dataWebsite('projectsSummaryList')) {
        apolloClientQuery(PROJECTS_SUMMARY_QUERY[locale])
          .then(data => {
            commit(SET_WEBSITE_PROPERTY, {
              field: 'projectsSummaryList',
              value: data.projectsCollections
            });
            resolve();
          })
          .catch(err => {
            commit('ERROR_OCCURRED', err, {
              root: true
            });
            reject();
          });
      } else {
        resolve();
      }
    }),

  [GET_PROJECTS_FOR_HOME_DATA]: ({ commit, getters }, locale) =>
    new Promise((resolve, reject) => {
      if (!getters.dataWebsite('projectsListForHome')) {
        apolloClientQuery(PROJECTS_FOR_HOME_QUERY[locale], {}, false)
          .then(data => {
            commit(SET_WEBSITE_PROPERTY, {
              field: 'projectsListForHome',
              value: data.projectsCollections
            });
            resolve();
          })
          .catch(err => {
            commit('ERROR_OCCURRED', err, {
              root: true
            });
            reject();
          });
      } else {
        resolve();
      }
    }),

  [GET_PROJECT_BY_SLUG_DATA]: ({ commit }, { slug, locale }) =>
    new Promise((resolve, reject) => {
      apolloClientQuery(PROJECT_BY_SLUG[locale], { slug })
        .then(data => {
          commit(SET_WEBSITE_PROPERTY, {
            field: 'projectDetail',
            value:
              data.projectsCollections && data.projectsCollections.length === 1
                ? data.projectsCollections[0]
                : null
          });
          resolve();
        })
        .catch(err => {
          commit('ERROR_OCCURRED', err, {
            root: true
          });
          reject();
        });
    }),

  [GET_REVIEWS_DATA]: ({ commit, getters }, locale) =>
    new Promise((resolve, reject) => {
      if (!getters.dataWebsite('reviewsList')) {
        apolloClientQuery(REVIEWS_QUERY[locale])
          .then(data => {
            commit(SET_WEBSITE_PROPERTY, {
              field: 'reviewsList',
              value: data.reviews
            });
            resolve();
          })
          .catch(err => {
            commit('ERROR_OCCURRED', err, {
              root: true
            });
            reject();
          });
      } else {
        resolve();
      }
    }),

  [GET_EMPLOYEES_DATA]: ({ commit, getters }, locale) =>
    new Promise((resolve, reject) => {
      if (!getters.dataWebsite('team')) {
        apolloClientQuery(EMPLOYEES_QUERY[locale])
          .then(data => {
            commit(SET_WEBSITE_PROPERTY, {
              field: 'team',
              value: data.employees
            });
            resolve();
          })
          .catch(err => {
            commit('ERROR_OCCURRED', err, {
              root: true
            });
            reject();
          });
      } else {
        resolve();
      }
    }),

  // eslint-disable-next-line no-unused-vars
  [CREATE_GET_IN_TOUCH]: ({ commit }, payload) =>
    new Promise((resolve, reject) => {
      apolloClientMutate(CREATE_GET_IN_TOUCH_MUTATION, payload)
        .then(data => {
          resolve(data);
        })
        .catch(err => {
          reject(err);
        });
    })
};
